/* istanbul ignore file */
import { DropdownMenu } from 'framework/ui/menu';
import React from 'react';
import JournalEntryStornoToggler from 'domain/finance/journalEntry/shared/Settings/JournalEntryStornoToggler';
import SettingsIcon from '@mui/icons-material/SettingsOutlined';
import IconButton from '@mui/material/IconButton';

const JournalEntrySettings = () => {
  return (
    <DropdownMenu
      popupId="journal-entry-settings"
      iconButton={
        <IconButton className="dropdown-toggle">
          <SettingsIcon />
        </IconButton>
      }
    >
      <JournalEntryStornoToggler />
    </DropdownMenu>
  );
};

export default JournalEntrySettings;
